/**
 * Cashier Add Card SC Model
 */

define(function(require, exports, module) {
    'use strict';
    var BaseModel = require('common/base.model');
    var server = require('server');
    var urlUtil = require('util/url.util');
    var device = require('util/device.util');
    var config = require('config');
    var _ = require('underscore');
    var user = require('user');
    var language = require('util/language.util');
    var payment = require('common/payment.util');

    module.exports = BaseModel.extend({

        sync: function(method, model, options) {
            if (method === 'read') {
                return this.getMerchantData()
                    .done(options.success)
                    .fail(options.error);
            }
        },

        parse: function(response) {
            var portalUrlParams = urlUtil.getURLParams();
            var isNative = portalUrlParams.isNative;
            var userLang = language.getTwoLetterLanguage(user.get('lang'));
            var headerParameters = response.data.headerParameters;
            var location = headerParameters && headerParameters.Location && headerParameters.Location[0];

            var getParams = _.extend(
                { language: portalUrlParams.language || userLang },
                isNative && { isNative: isNative }
            );

            if (location) {
                headerParameters.Location[0] += (location.includes('?') ? '&' : '?') + urlUtil.serialize(getParams);
            }

            return {
                headerParameters: payment.convertHeaderParameters(headerParameters)
            };
        },

        /**
         * Get merchant data from Open API
         * @return {Deferred}
         */
        getMerchantData: function() {
            return server.send(_.extend({
                ID: 33008,
                casinoName: config.get('casinoName'),
                clientPlatform: device.clientPlatform,
                clientType: config.get('clientType'),
                realMode: config.get('realMode'),
                description: 'Register Payment Method Account',
                responses: [33009, 33010]
            }, this.getUrls()));
        },

        /**
         * Adjust SafeCharge response to imitate Open API response
         * @param  {Object} data        SafeCharge response
         * @return {Object}             Converted SafeCharge response to Open API response
         */
        formatAddedPaymentAccount: function(data) {
            return {
                data: {
                    payments: {
                        method: [{
                            account: [{
                                specificParams: {
                                    accountId: '*' + data.accountId
                                },
                                code: data.accountCode
                            }],
                            code: data.methodCode
                        }]
                    }
                }
            };
        },

        getUrls: function() {
            var tokenProvider = this.get('tokenProvider');
            var createUrlForVisaCheckout = function(status) {
                var url = new URL(location);

                url.searchParams.append('status', status);

                return url.toString();
            };
            var createUrlForSafeCharge = function(status) {
                var url = new URL(location.origin + '/' + config.get('themeName') +
                    '/js/app-out/payment.html');

                url.searchParams.append('type', 'addcard');
                url.searchParams.append('status', status);
                url.searchParams.append('domain', document.domain);

                return url.toString();
            };
            var createUrlMethod = tokenProvider === 'visacheckout'
                ? createUrlForVisaCheckout
                : createUrlForSafeCharge;

            return {
                tokenProvider: tokenProvider,
                errorUrl: createUrlMethod('error'),
                cancelUrl: createUrlMethod('cancel'),
                successUrl: createUrlMethod('success'),
            };

        }

    });

});
